export const authDataFormStrong = {
	email: {
		required: true,
		format: "email",
	},
	password: {
		format: "strong-password",
		required: true,
	},
	secondEmail: {
		required: true,
		couple: "email",
		coupleLabel: "e-mailadres",
		format: "email",
	},
	secondPassword: {
		required: true,
		couple: "password",
		coupleLabel: "wachtwoord",
		format: "strong-password",
	},
};
